import React from 'react';

import { DashboardLayout } from '@hero/layouts';

import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

import { authRoutes } from './auth';
import { automationRoutes } from './automation';
import { collectionRoutes } from './collections';
import { contactRoutes } from './contacts';
import { inviteRoutes } from './invite';
import { newAutomationRoutes } from './new-automation';
import { newRecognitionRoutes } from './new-recognition';
import { recognitionRoutes } from './recognition';
import { rootRoutes } from './root';
import { sendGiftRoutes } from './send-gift';
import { settingsRoutes } from './settings';

export const routes = [
  {
    path: '/',
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: lazyLoadPage(''),
        state: {
          pageKey: 'home',
          metadata: {
            title: 'Home'
          }
        }
      },
      {
        path: paths.DASHBOARD,
        element: lazyLoadPage('/dashboard', { path: '(dashboard)' }),
        state: {
          pageKey: 'dashboard',
          metadata: {
            title: 'Dashboard'
          },
          shoppingCart: {
            floatingButton: {
              location: { x: 48, y: 36 }
            }
          }
        }
      },
      {
        path: paths.LEARNING_CENTER,
        element: lazyLoadPage('/learning-center', { path: '(dashboard)' }),
        state: {
          pageKey: 'learningCenter',
          metadata: {
            title: 'Learning center'
          }
        }
      },
      {
        path: paths.GIFT_CATALOG,
        element: lazyLoadPage('/gift-catalog', { path: '(dashboard)' }),
        state: {
          pageKey: 'productList',
          metadata: {
            title: 'Gift catalog'
          },
          shoppingCart: {
            floatingButton: {
              location: { x: 79, y: 24 }
            },
            browseShoppingButtonEnabled: false
          }
        }
      },
      {
        path: paths.GRATITUDE_BOARD,
        element: lazyLoadPage('/gratitude-board', { path: '(dashboard)' }),
        state: {
          pageKey: 'gratitudeBoard',
          metadata: {
            title: 'Gratitude board'
          }
        }
      },
      ...automationRoutes,
      ...collectionRoutes,
      ...contactRoutes,
      ...settingsRoutes,
      ...newRecognitionRoutes,
      ...recognitionRoutes,
      ...newAutomationRoutes,
      ...sendGiftRoutes
    ]
  },
  ...inviteRoutes,
  ...authRoutes,
  ...rootRoutes
];
